import { c as _c } from "react/compiler-runtime";
interface CollectionBreadcrumbsProps {
  readonly collectionLabel: string;
  readonly tokenLabel?: string | undefined;
  readonly grantLabel?: string | undefined;
  readonly onNavigateToCollections: () => void;
  readonly onNavigateToTokens?: (() => void) | undefined;
  readonly onNavigateToContributors?: (() => void) | undefined;
}
export function CollectionBreadcrumbs(t0) {
  const $ = _c(6);
  const {
    tokenLabel,
    grantLabel,
    onNavigateToCollections,
    onNavigateToTokens,
    onNavigateToContributors
  } = t0;
  const backAction = grantLabel ? onNavigateToContributors : tokenLabel ? onNavigateToTokens : onNavigateToCollections;
  const backLabel = grantLabel ? "Back" : tokenLabel ? "Back" : "Back to collections";
  if (!backAction) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span aria-hidden="true">←</span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== backLabel) {
    t2 = <span>{backLabel}</span>;
    $[1] = backLabel;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== backAction || $[4] !== t2) {
    t3 = <nav aria-label="Navigation" className="tw-flex tw-items-center"><button type="button" onClick={backAction} className="tw-inline-flex tw-items-center tw-gap-1.5 tw-bg-transparent tw-p-0 tw-border-none tw-outline-none tw-text-sm tw-font-medium tw-text-iron-400 tw-transition-colors desktop-hover:hover:tw-text-iron-200 focus:tw-outline-none focus:tw-ring-0">{t1}{t2}</button></nav>;
    $[3] = backAction;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}